var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Match from "../common/sportsGrid/Match";
import { FormattedMessage, defineMessages } from 'react-intl';
import { winWithoutDraw } from '../common/sportsGrid/matchType';
import { getMomentLocale } from '../../../shared/momentLocale';
var messages = defineMessages({
    grid_w1: {
        id: "grid.w1",
        defaultMessage: "П1"
    },
    grid_x: {
        id: "grid.x",
        defaultMessage: "X"
    },
    grid_w2: {
        id: "grid.w2",
        defaultMessage: "П2"
    },
});
var MatchesGroup = /** @class */ (function (_super) {
    __extends(MatchesGroup, _super);
    function MatchesGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatchesGroup.prototype.render = function () {
        var _a = this.props, matchIds = _a.matchIds, section = _a.section, startDate = _a.startDate, gridLocalization = _a.gridLocalization, sportId = _a.sportId, languageId = _a.languageId;
        var renderMatches = [];
        var whoHigher = sportId === 14 || sportId === 37 || this.props.whoHigher;
        var sectionCls = whoHigher ? 'section whohigher' : 'section';
        var props = {
            gridLocalization: gridLocalization,
            section: section,
            whoHigher: whoHigher
        };
        matchIds.map(function (m) {
            renderMatches.push(_jsx(Match, __assign({ id: m }, props), m));
        });
        var locale = getMomentLocale(languageId);
        var cls = winWithoutDraw.find(function (m) { return m === sportId; }) ? ' win-without-draw' : '';
        var timeStyles = whoHigher ? { minHeight: 30, border: 'none' } : { minHeight: 30 };
        return (_jsxs("div", __assign({ className: sectionCls }, { children: [_jsx("div", __assign({ className: 'subhead' }, { children: _jsxs("div", __assign({ className: "subhead-inner".concat(cls) }, { children: [_jsx("div", __assign({ className: 'time', style: timeStyles }, { children: moment(startDate, 'MM-DD-YYYY').locale(locale).format('DD MMMM') })), whoHigher ? null : (_jsxs("div", __assign({ className: 'labels' }, { children: [_jsx("div", __assign({ className: 'label' }, { children: _jsx("span", { children: _jsx(FormattedMessage, __assign({}, messages.grid_w1)) }) })), !winWithoutDraw.find(function (m) { return m === sportId; }) && _jsx("div", __assign({ className: 'label' }, { children: _jsx("span", { children: _jsx(FormattedMessage, __assign({}, messages.grid_x)) }) })), _jsx("div", __assign({ className: 'label' }, { children: _jsx("span", { children: _jsx(FormattedMessage, __assign({}, messages.grid_w2)) }) }))] })))] })) })), _jsx("div", __assign({ className: 'items' }, { children: renderMatches }))] })));
    };
    MatchesGroup.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired,
        languageId: PropTypes.number.isRequired,
        startDate: PropTypes.any.isRequired,
        matchIds: PropTypes.object.isRequired,
        sportId: PropTypes.number.isRequired
    };
    return MatchesGroup;
}(React.Component));
export default MatchesGroup;



// WEBPACK FOOTER //
// ./src/components/grid/sports/MatchesGroup.jsx